import { CustomButton, CustomInputSelect } from '@Modules/core/components';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { FormInputMeta } from '@Modules/core/types/FormMetaType';

export interface IAccountSetupDatatable {
  hpxAccount: string;
  account: string;
  solde: string;
  devise: string;
}

// export const AccountSetupDatatableDeviseMeta: FormInputMeta = {
//   name: 'devise',
//   options: [
//     {
//       label: 'CFA Franc BEAC',
//       value: 'fcfa-beac',
//       selected: true,
//     },
//   ],
// };

const columns = (handleEdit: any) => [
  {
    id: 'hpxAccount',
    header: 'Compte HPX',
    accessorKey: 'hpxAccount',
    cell: (ctx: any) => ctx.getValue(),
  },
  {
    id: 'account',
    header: 'Compte',
    accessorKey: 'account',
    cell: (ctx: any) => ctx.getValue(),
  },
  {
    id: 'solde',
    header: 'Solde',
    accessorKey: 'solde',
    cell: (ctx: any) => ctx.getValue(),
  },
  {
    id: 'devise',
    header: 'Devise',
    accessorKey: 'devise',
    cell: (ctx: any) => ctx.getValue(),
    // cell: (ctx: any) => {
    //   // const row = ctx.row.origial;
    //   return (
    //     <CC.Box>
    //       <CustomInputSelect
    //         defaultValue={ctx.getValue()}
    //         meta={AccountSetupDatatableDeviseMeta}
    //       ></CustomInputSelect>
    //     </CC.Box>
    //   );
    // },
  },

  {
    id: 'action',
    header: 'Action',
    accessorKey: 'action',
    cell: (ctx: any) => {
      const row = ctx.row.origial;
      return (
        <CC.Box>
          <CustomButton onClick={() => handleEdit(row)}>Editer</CustomButton>

          {/* <CustomButton onClick={() => handleDel(row)} variant="ghost" ml="2">
            Supp
          </CustomButton> */}
        </CC.Box>
      );
    },
  },
];

export const AccountSetupDatatableMeta = {
  columns,
};
